import { DataService } from "../../services/data.service";
import { BusinesLogicService } from "../../services/business-logic.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
var CancelComponent = (function () {
    function CancelComponent(_data, _blogic) {
        this._data = _data;
        this._blogic = _blogic;
        this.destroy$ = new Subject();
    }
    CancelComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* Cancel action */
    CancelComponent.prototype.cancel = function () {
        var _this = this;
        var params;
        if (this._data.configuration["activeSupervisor"] &&
            this._data.selectedTurn != null) {
            params = {
                turn_id: this._data.selectedTurn["id"],
                queue_id: this._data.selectedTurn["queue_id"],
                desk_id: this._data.selectedTurn["desk"],
                deskuser: this._data.session["username"],
                deskoperator: this._data.session["operator"]
            };
        }
        else {
            params = {
                turn_id: this._data.turn["id"],
                queue_id: this._data.turn["queue_id"],
                desk_id: this._data.session["desk"],
                deskuser: this._data.session["username"],
                deskoperator: this._data.session["operator"]
            };
        }
        this._blogic.cancelOperation(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            _this._data.closeTurn();
            _this._data.selectedTurn = null;
            if (_this._data.session["autosupervisor"] && _this._data.session["queuemode"] == 'Q') {
                var params2 = {
                    desk_id: _this._data.session["desk"],
                    status: "I",
                    deskuser: _this._data.session["username"],
                    deskoperator: _this._data.session["operator"],
                };
                _this._blogic.deskNotify(params2)
                    .pipe(takeUntil(_this.destroy$))
                    .subscribe();
            }
        });
    };
    return CancelComponent;
}());
export { CancelComponent };
